import { useState } from "react";
import { api } from "@/lib/api";
import { useAuth } from "@/contexts/AuthContext";
import { useLang } from "@/contexts/LangContext";
import { toast } from "sonner";
import { MailWarning } from "lucide-react";

const R = {
  en: { msg: "Confirm your email address to secure your account.", resend: "Resend email", sent: "Confirmation email sent — check your inbox." },
  fr: { msg: "Confirme ton adresse email pour sécuriser ton compte.", resend: "Renvoyer l'email", sent: "Email de confirmation envoyé — regarde ta boîte mail." },
};

export default function VerifyBanner() {
  const { user } = useAuth();
  const { lang } = useLang();
  const r = R[lang] || R.en;
  const [busy, setBusy] = useState(false);
  if (!user || user.email_verified !== false) return null;

  const resend = async () => {
    setBusy(true);
    try { await api.post("/auth/resend-verification"); toast.success(r.sent); }
    catch (err) { toast.error(err?.response?.data?.detail || "Error"); }
    finally { setBusy(false); }
  };

  return (
    <div className="bg-[#F5B301]/10 border-b border-[#F5B301]/30 text-[#F5B301] text-xs sm:text-sm" data-testid="verify-banner">
      <div className="max-w-7xl mx-auto px-4 py-2 flex items-center gap-3 flex-wrap">
        <MailWarning className="w-4 h-4 shrink-0" />
        <span className="flex-1">{r.msg} <span className="text-slate-400">({user.email})</span></span>
        <button onClick={resend} disabled={busy} data-testid="verify-banner-resend" className="font-bold uppercase tracking-wider text-[11px] underline-offset-2 hover:underline disabled:opacity-50">{busy ? "…" : r.resend}</button>
      </div>
    </div>
  );
}
